import React from "react";
import { useParams } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { AppFlowViewer } from "../../components/appflow/AppFlowViewer";

/** Phase 222 — Parking Marshal Help: the marshal's own App Flow (opened from the Help icon in the header). */
export default function MarshalHelp() {
  const { code } = useParams();
  return (
    <div className="space-y-3" data-testid="marshal-help">
      <div>
        <h1 className="text-lg font-semibold font-heading flex items-center gap-2"><LifeBuoy className="h-5 w-5 text-primary" /> Help & App Flow</h1>
        <p className="text-xs text-muted-foreground">Your shift on the handheld, step by step. · हैंडहेल्ड पर आपकी शिफ़्ट, चरण दर चरण।</p>
      </div>
      <AppFlowViewer fetchPath={`/t/${code}/app-flow`} exportPath={`/t/${code}/app-flow/export.pptx`} compact />
    </div>
  );
}
